module.exports = __webpack_public_path__ + "img/keder_lichtblau_ral5012.2be1ee09.jpg";